import styled, { BorderRadius, Color, Spacing, Utils, Font, css } from '@nfinite/react-hubstairs/styled'

import TextInputComponent from 'components/Commons/Inputs/TextInput'
import IconComponent from 'components/Commons/Icon'

export const TextInput = styled(TextInputComponent)`
  width: auto;
  flex-grow: 1;
  & input {
    background-color: ${Color.get('gray', 'lighter')};
  }
  ${({ disabled }) =>
    disabled &&
    css`
      & svg {
        fill: ${Color.get('text', 'gray')} !important;
      }
      & input:disabled {
        color: ${Color.get('text', 'gray')};
      }
      & input::placeholder {
        color: ${Color.get('text', 'gray')};
      }
    `}
`

export const Icon = styled(IconComponent)`
  height: 100%;

  & svg {
    fill: ${Color.get('gray', 'dark')};
  }
`

export const Clear = styled(IconComponent)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > svg {
    width: 20px;
    height: 20px;
    fill: ${Color.get('text')};
  }
`

const INPUT_HEIGHTS = {
  xs: 30,
  sm: 36,
  regular: 50,
}
const LIGHT_ICON_SIZES = {
  xs: 10,
  sm: 20,
  regular: 20,
}
const LIGHT_ICON_FONT_SIZES = {
  xs: 's',
  sm: 's',
  regular: 'default',
}

const LIGHT_ICON_SPACINGS = {
  xs: 'xs',
  sm: 'xs',
  regular: 's',
}

export const LightInput = styled('div')`
  position: relative;
  min-height: ${({ size }) => INPUT_HEIGHTS[size]}px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${Spacing.generatePadding({ vertical: 'xxs' })}
`

LightInput.Wrapper = styled('div')`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: calc(
    100% - ${({ theme, size }) => LIGHT_ICON_SIZES[size] * 2 + theme.getSpacing(LIGHT_ICON_SPACINGS[size]) * 2}px
  );
  ${({ fillSpace }) =>
    fillSpace &&
    css`
      width: 100%;
    `}
`

LightInput.Text = styled('div')`
  height: 100%;
  visibility: hidden;
  ${Utils.generateEllipsis()}
  ${Spacing.generatePadding({ right: 'xs' })}
  ${({ size }) => Font.generate({ size: LIGHT_ICON_FONT_SIZES[size] })};
`

LightInput.Icon = styled(IconComponent)`
  width: ${({ size }) => LIGHT_ICON_SIZES[size]}px;
  min-width: ${({ size }) => LIGHT_ICON_SIZES[size]}px;
  height: ${({ size }) => LIGHT_ICON_SIZES[size]}px;

  fill: ${Color.get('gray', 'dark')};
  ${({ size }) => Spacing.generateMargin({ right: LIGHT_ICON_SPACINGS[size] })};
`

LightInput.Clear = styled(IconComponent)`
  width: ${({ size }) => LIGHT_ICON_SIZES[size]}px;
  min-width: ${({ size }) => LIGHT_ICON_SIZES[size]}px;
  height: ${({ size }) => LIGHT_ICON_SIZES[size]}px;
  fill: ${Color.get('text')};
  ${({ size, fillSpace }) =>
    Spacing.generateMargin({
      right: LIGHT_ICON_SPACINGS[size],
    })};
  cursor: pointer;
`

LightInput.Field = styled('input')`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  color: ${Color.get('text')};
  ${Spacing.generatePadding({ all: '0' })}
  background-color: transparent;
  border: 0px solid transparent;
  ${BorderRadius.generate({ all: 'm' })}
  ${({ size }) => Font.generate({ size: LIGHT_ICON_FONT_SIZES[size] })};

  :focus,
  :active {
    outline: none;
  }

  ::placeholder {
    color: ${Color.get('gray', 'dark')};
  }
`
